import { Typography } from "antd";
import { useResponsive } from "app/hooks/useResponsive";
import React from "react";
const { Title, Text } = Typography;

const PageHeader = ({ title, subTitle, extra, className, ...props }) => {
  const { isMobile } = useResponsive();

  return (
    <div
      className={className}
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: isMobile ? "flex-start" : "center",
        flexDirection: isMobile ? "column" : "row",
        gap: isMobile ? 12 : 16,
        flexWrap: "wrap",
      }}
      {...props}
    >
      <div style={{ flex: "1 1 auto", minWidth: 250 }}>
        <Title level={3} style={{ margin: 0, fontWeight: 700 }}>
          {title}
        </Title>
        {subTitle && (
          <Text type="secondary" style={{ fontSize: 14 }}>
            {subTitle}
          </Text>
        )}
      </div>
      {extra && (
        <div
          style={{
            width: isMobile ? "100%" : undefined,
            flex: "1 1 auto",
            display: "flex",
            justifyContent: isMobile ? "flex-start" : "flex-end",
          }}
        >
          {extra}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
